// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PostMenu__item--admin":"qz_a","PostMenu__item--moderator":"qz_b","PostMenu__item--author":"qz_c"};